import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';

import { ChangeDeviceService } from '@app/shared/services/change-device.service';
import { ChangeStepService } from '@app/core/components/stepper/service/change-step.service';
import { CoreModule } from '@app/core/core.module';
import { SaveDataService } from '@app/shared/services/save-data.service';

@Component({
    selector: 'app-financing-start',
    standalone: true,
    imports: [CoreModule, CommonModule, TranslateModule],
    templateUrl: './financing-start.component.html',
    styleUrl: './financing-start.component.scss',
})
export class FinancingStartComponent {

    private saveDataService = inject(SaveDataService);

    continueButton = 'common.buttons.continueButton';

    financingTitle = 'features.financingStart.financingTitle';
    financingSubtitle = 'features.financingStart.financingSubtitle';

    identityDocument = 'features.financingStart.identityDocument';
    rememberValidity = 'features.financingStart.rememberValidity';
    mobilePhone = 'features.financingStart.mobilePhone';
    authenticateMobilePhone = 'features.financingStart.authenticateMobilePhone';
    internetConnection = 'features.financingStart.internetConnection';
    processQuick = 'features.financingStart.processQuick';

    continueButtonDisabled = true;

    isPortraitDevice = false;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private changeDeviceService: ChangeDeviceService,
        private changeStepService: ChangeStepService,
    ) {
        this.changeStepService.changeStep(0);
    }

    ngOnInit() {
        this.continueButtonDisabled = false;

        this.isPortraitDevice = this.changeDeviceService.isPortraitDevice;
        this.changeDeviceService.changedDevice.subscribe((value) => {
            this.isPortraitDevice = value;
        });
    }

    //-------------------------//
    //--------NAVIGATION-------//
    //-------------------------//

    onClicButtonContinue() {
        this.router.navigate(['/main/privacy-settings'], { relativeTo: this.route });
    }

    ngOnDestroy() {}
}
